import { type ViewLikesContextAction } from './dispatchTypes'
import {
    type IViewLikesContextState,
    ViewLikesContextActionType
} from './types'

export const ViewLikesContextReducer = (
    prevState: IViewLikesContextState,
    action: ViewLikesContextAction
): IViewLikesContextState => {
    switch (action.type) {
        case ViewLikesContextActionType.SET_SEARCH_TERM:
            return { ...prevState, searchTerm: action.payload }
        case ViewLikesContextActionType.SET_SORT_DIRECTION:
            return { ...prevState, sortDirection: action.payload }
        default:
            return prevState
    }
}
